<app-auth-layout>
  <img class="logo" src="./assets/images/logo.svg" />
  <app-error *ngIf="errcode" [errcode]="errcode" />
  <h1>Verify your email</h1>

  <ng-container *ngIf="authenticated">
    <ng-container *ngIf="spinner">
      <sync-spinner />
  
      <p>Verifying your email.<br />Upon success, you will be redirected to Sync.</p>
    </ng-container>
  
    <ng-container *ngIf="errcode">
      <p>Please try again with a different link to verify your email.</p>
      <sync-button
        label="Resend verification link"
        size="large"
        [onClick]="resendVerification"
        [isLoading]="verificationSpinner">
      </sync-button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!authenticated">
    <p>Please try again with a different link to verify your email.</p>
    <sync-divider />
    <p>Sign in to resend the verification link</p>
    <sync-button label="Sign in" size="large" routerLink="/login" />
  </ng-container>
</app-auth-layout>
